<template lang="html">
    <div>
<!--        <div class="loader-wrap" v-if="!loaded">-->
<!--            <div class="loader-content">-->
<!--                <div class="loader">-->
<!--                    <div class="loader__item">-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

       <div class="content">
           <h1>Zákazníci</h1>

           <v-layout  class="layout--controls">


             <v-btn
                 color="secondary"
                 class="button--top control"
                 :href="exportLink"
                 download
             >Exportovat</v-btn>
               <v-text-field
                       class="input--search control"
                       placeholder="Vyhledat"
                       outlined
                       v-model="search"
               ></v-text-field>
           </v-layout>
               <v-layout class="table-items">



                   <v-data-table
                       locale="cs"
                       :headers="headers"
                       :items="items"
                       item-key="name"
                       :items-per-page="perPage"
                       :mobile-breakpoint='0'
                       :options.sync="options"
                       :server-items-length="total"
                       class="elevation-1 full-width frankjoy-table"
                   >
                     <template #progress>
                       <div></div>
                     </template>

                       <template slot="body" slot-scope="props">
                           <tbody style="min-height: 400px">
                           <tr v-for="item in props.items" :key="item.id" >
                            <router-link :to="{name:'CustomersDetail', params: {id: item.id}}" >
                                <td class="">{{item.id}} <span v-if="item.deleted_at"><span class="bold status status--error">Smazán</span></span></td>
                                <td class="">{{item.forename}}</td>
                                <td class="">{{item.surname}}</td>
                                <td class="bold">{{item.email}}</td>
                                <td class="bold">
                                   <span class="actual-price">
                                       <span v-if="orders.filter(order => order.user_id === item.id).reduce(function(prev, cur) {return prev + parseFloat(cur.price);}, 0)">
                                        {{orders.filter(order => order.user_id === item.id).reduce(function(prev, cur) {return prev + parseFloat(cur.price);}, 0)}} Kč
                                       </span>
                                       <span v-else>
                                           0 Kč
                                       </span>
                                   </span>
                                    <br>
                                    <span class="normal small"><span class="small">Bez DPH</span>  {{orders.filter(order => order.user_id === item.id).reduce(function(prev, cur) {return prev + parseFloat(cur.price);}, 0) - (orders.filter(order => order.user_id === item.id).reduce(function(prev, cur) {return prev + parseFloat(cur.price);}, 0) * 0.1)}} Kč</span>


                                </td>

                                <td class="small">{{formatLastLog(item.last_log)}}<span class="bold" v-if="item.device"> z {{item.device}}</span></td>
                                <td class="right">
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            class="button--small"
                                    >Detail</v-btn>
                                </td>
                            </router-link>



                           </tr>
                           <div v-if="props.items.length == 0" class="text-no-results">
                               <p>Žádný zákazník nebyl nalezen</p>
                           </div>
                           <v-overlay
                               absolute
                               color="rgba(255, 255, 255, 0.8)"
                               :value="!loaded"
                           >
                                <div>
                                   <div class="loader">
                                       <div class="loader__item">
                                       </div>
                                   </div>
                                </div>
                           </v-overlay>
                           </tbody>

                       </template>


                       <template slot="footer" slot-scope="totals">

                           <div class="table-footer"  v-bind:class="{'footer--no-results': totals.props.pagination.pageStop === 0}">
                               <div class="table-footer__text">
                                   Počet zákazníků na stránce
                               </div>
                               <div class="table-footer__pages">
                                   <span v-if="totals.props.pagination.pageStop > 0"><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart + 1}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                                   <span v-else><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                               </div>
                           </div>
                       </template>
                   </v-data-table>


               </v-layout>

       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
        import moment from 'moment';
    import VueJsonToCsv from 'vue-json-to-csv'
    import {debounce} from "lodash";
    export default {
        name: 'Customers',
        components: {
            VueJsonToCsv
        },



        data() {
            return {
                json: {
                  data: [],
                  labels: {},
                  title: 'Zákazníci',
                  file: 'Zákazníci',
                  meta: [
                    [{
                      "key": "charset",
                      "value": "utf-8"
                    }]
                  ],
                },
                loaded: false,
                search: '',
                orders: [],
                headers: [
                    //  { text: '', value: '',  align: 'left',sortable: false },
                    { text: 'ID', value: 'id',  align: 'left',  },
                    { text: 'Jméno', value: 'forename',  align: 'left',  },
                    { text: 'Příjmení', value: 'surname',  align: 'left',  },
                    { text: 'E-mail', value: 'email',  align: 'left',  },
                    { text: 'Hodnota objednávek', value: 'orders_price',  align: 'left', sortable: false },
                    { text: 'Poslední přihlášení', value: 'last_log',  align: 'left',  },
                    { text: '', value: 'controls',  align: 'right',  }
                ],
                options: {},
                total:0,
                perPage: 30,
                items: []
            }
        },

        async created() {
            this.fetchData();
        },
        computed: {
            ...mapState(['profile']),
            exportLink() {
              return process.env.VUE_APP_API_BASE_URL + '/admin/users.xlsx?token=' + localStorage.getItem('token');
            },
        },
        mounted(){

        },
        methods: {
            formatLastLog(date){
                if(date){
                    return moment.unix(date).format('D.M.YYYY - HH:mm');
                }else{
                    return 'nikdy nepřihlášen';
                }

            },
            formatCreatedAt(date){
                if(date){
                    return moment.unix(date).format('D.M.YYYY - HH:mm');
                }else{
                    return null;
                }

            },
            fetchData(){
                this.loaded = false;
                this.items = [];
                const params = {};
                if(this.options.page){
                    params.page = this.options.page;
                }
                if(this.options.itemsPerPage)
                {
                    params.perPage = this.options.itemsPerPage;
                }
                if(this.options.sortBy && this.options.sortBy.length > 0){
                    params.sortBy = this.options.sortBy[0];
                }
                if(this.options.sortDesc && this.options.sortDesc.length > 0){
                    params.order = this.options.sortDesc[0] ? 'DESC' : 'ASC';
                }
                if(this.search && this.search.length > 0){
                    params.search = this.search;
                }
                this.$axios.get('/admin/users', { params }).then((response) => {

                  this.orders = response.data.orders;
                  this.items = response.data.users;
                  this.loaded = true;
                  this.total = response.data.count;

                }).catch((e) => {
                    this.loaded = true;
                });
            },
        },
        watch: {
          options() {
            this.fetchData();
          },
          search: debounce(function() {
            this.fetchData();
          }, 350)
        }
    }
</script>


<style lang="scss">


</style>
